/** @jsxImportSource @emotion/react */
import Bingo from "../../assets/images/Bingo.png";
import { Bingo_Url } from "../../connections";
import { doodleBackgroundImage } from "../../utils/doodlePattern";

const RING_GREEN = "#8bc34a";

const styles = {
  wrapper: {
    position: "fixed",
    bottom: 90,
    right: 20,
    zIndex: 1300,
  },
  pulseRing: {
    position: "absolute",
    inset: 0,
    borderRadius: 999,
    border: `2px solid ${RING_GREEN}`,
    animation: "bingoFabPulse 2.2s ease-out infinite",
    pointerEvents: "none",
  },
  pulseRingDelayed: {
    animationDelay: "1.1s",
  },
  badge: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 50,
    padding: "0 18px",
    borderRadius: 999,
    backgroundColor: "#2e7d32",
    backgroundImage: doodleBackgroundImage,
    backgroundSize: "300px 300px",
    backgroundRepeat: "repeat",
    border: `2px solid ${RING_GREEN}`,
    boxShadow: `0 8px 24px rgba(15, 23, 42, 0.32), 0 0 10px rgba(139, 195, 74, 0.5)`,
    animation: "bingoFabBounce 2.6s ease-in-out infinite",
    textDecoration: "none",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "scale(1.06)",
      boxShadow: `0 10px 28px rgba(15, 23, 42, 0.4), 0 0 16px rgba(139, 195, 74, 0.7)`,
    },
  },
  logo: {
    display: "block",
    height: 36,
    width: "auto",
    objectFit: "contain",
    transform: "translateY(-3px)",
    // Crisp outline (not a soft glow): tiny near-zero-blur offsets stamped
    // in 8 directions around the shape, instead of a large blur radius that
    // reads as faded.
    filter:
      "drop-shadow(1.5px 0 0.3px #fff) drop-shadow(-1.5px 0 0.3px #fff) " +
      "drop-shadow(0 1.5px 0.3px #fff) drop-shadow(0 -1.5px 0.3px #fff) " +
      "drop-shadow(1.1px 1.1px 0.3px #fff) drop-shadow(-1.1px -1.1px 0.3px #fff) " +
      "drop-shadow(1.1px -1.1px 0.3px #fff) drop-shadow(-1.1px 1.1px 0.3px #fff)",
  },
};

// Fixed, animated shortcut to Bingo — surfaced as a floating overlay
// alongside the header logo so it stays visible and eye-catching on every
// page.
const BingoFloatingButton = () => (
  <div css={styles.wrapper}>
    <span css={styles.pulseRing} />
    <span css={[styles.pulseRing, styles.pulseRingDelayed]} />
    <a
      href={Bingo_Url}
      target="_blank"
      rel="noreferrer"
      aria-label="Play Bingo"
      css={styles.badge}
    >
      <img src={Bingo} alt="Bingo" css={styles.logo} />
    </a>
    <style>{`
      @keyframes bingoFabPulse {
        0% { transform: scale(0.9); opacity: 0.85; }
        70% { transform: scale(1.7); opacity: 0; }
        100% { transform: scale(1.7); opacity: 0; }
      }
      @keyframes bingoFabBounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
      }
    `}</style>
  </div>
);

export default BingoFloatingButton;
